export const fieldTranslations = {
  name: "Nom",
  isin: "ISIN",
  code: "Code",
  currency: "Devise",
  strategy_id: "ID de la stratégie",
  nav_group: "Groupe NAV",
  category: "Catégorie",
  company_name: "Nom de la société",
  issuer_name: "Nom de l'émetteur",
  asset_class_1: "Classe d'actifs",
  asset_class_2: "Sous-classe d'actifs",
  maturity_date: "Date de maturité",
  coupon_rate: "Taux de coupon",
  owner: "Propriétaire",
  property_type: "Type de bien",
  property_size: "Surface",
  financing_own_funds: "Fonds propres",
  financing_mortage: "Hypothèque",
  commitment: "Engagement",
  counterparty: "Contrepartie",
  capital_callable: "Capital appelable",
  stock_option_strike: "Strike de l'option",
  concentrated_asset: "Actif concentré",
  loan_amount_granted: "Montant du prêt accordé",
  loan_with_collateral: "Prêt avec garantie",
  loan_rate: "Taux du prêt",
  issuer_id: "ID émetteur",
  c3_time_serie_file_id: "ID fichier série temporelle",
  structured_product_type: "Type de produit structuré",
  structured_product_basket_type: "Type de panier",
  structured_product_strike_date: "Date de strike",
  structured_product_comments: "Commentaires",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
